import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { updateFavoriteMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

// HOOK
const useUpdateFavoriteMeal = () => {
    const [isUpdating, setIsUpdating] = useState(false);
    const queryClient = useQueryClient();

    // MUTATION
    const mutation = useMutation({
        mutationFn: (data) => updateFavoriteMeal(data),
        onError: (error) => console.error('Failed to update favorite meal:', error)
    });

    // ACTION
    const updateFavoriteMealAndSync = async (data) => {
        setIsUpdating(true);

        try {
            await mutation.mutateAsync(data);
            await refetchDiaryAndEnergy(queryClient);
        } catch (error) {
            console.error('Update and sync failed:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return {
        updateFavoriteMeal: updateFavoriteMealAndSync,
        isUpdating,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useUpdateFavoriteMeal;
